/** @jsxImportSource @emotion/react */

import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { ReactComponent as RefreshIcon } from "assets/common/icons/refresh.svg";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useSelector } from "react-redux";
import { selectUsername } from "store/auth";
import { selectBalance, selectBalanceLoading, selectProfile } from "store/user";
import { getMemberBalance } from "store/user/user.thunk";

import { SurplusStyle } from "./index.style";

const Surplus = () => {
  const dispatch = useAppDispatch();

  const profile = useAppSelector(selectProfile);
  const balanceMember = useAppSelector(selectBalance);
  const username =
    useSelector(selectUsername) || localStorage.getItem("username") || "";

  const isLoading = useSelector(selectBalanceLoading);

  return (
    <div css={SurplusStyle.self}>
      <Avatar
        size={60}
        icon={<UserOutlined style={{ color: "#545454" }} />}
        style={{ backgroundColor: "#fff" }}
        src={null}
        alt="avatar-user"
      />
      <div css={SurplusStyle.username}>Tài khoản {profile?.username}</div>
      <div css={SurplusStyle.surplus}>
        <span>Số dư: {balanceMember?.total || 0}</span>
        <RefreshIcon
          css={SurplusStyle.refresh}
          onClick={() => {
            if (isLoading) return;
            dispatch(getMemberBalance({ username }));
          }}
          data-loading={isLoading && "loading"}
        />
      </div>
    </div>
  );
};

export default Surplus;
